<template>
  <section class="table-responsive table-scrollable">
    <button type="button" class="btn btn-warning" @click="handleOnClickRunner()">{{ lang['autoRunStatusText_' + autoRunStatus] }}</button>
    <table class="table table-bordered table-striped table-hover">
      <thead>
      <tr>
        <th>Tables Id </th>
        <th>Title</th>
        <th>Remaining</th>
        <th>Shoe Id</th>
        <th>Round</th>
        <th>Status</th>
        <th>Games Id</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(table,index) in tables">
        <games-machine-control :user-id="userId" :table="table" :game-key = "table.key"></games-machine-control>
      </template>
      </tbody>
    </table>
    <br/>
    <hr/>
  </section>
</template>
<script>
  export default {
    name: 'games-machine',
    props: {
      userId: {
        required: true,
        type: [String, Number]
      },
      tables: {
        required: true,
        type: [Array]
      },
      runner: {
        required: true,
      },
    },
    data() {
      return {
        autoRunStatus: 0,
        lang: {
          'autoRunStatusText_0': 'Start Runner',
          'autoRunStatusText_1': 'Stop Runner'
        }
      }
    },
    computed: {},
    methods: {
      handleOnClickRunner() {
        const request = {
          set_auto_run: 1
        }
        axios.post(`/keno/set-auto-run`, request)
          .then(response => {
            this.autoRunStatus = response.data.status
          })
          .catch(err => {
            if (typeof errorCb === 'function') {
              console.log(err)
            }
            this.$notify.error({
              message: _.get(err.response, 'data.0.message', '') + _.get(err.response, 'data.error', ''),
              offset: 50,
              duration: 10000
            })
          })
      },
    },
    mounted() {
      this.autoRunStatus = this.runner
    },
    watch: {
//      'runner': {
//        handler: function (val, old) {
//        }
//      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/admin/pages/games-machine/app.vue